// The Spraytan Queen — shared theme behavior (loader, cursor, nav)
// Runs on every page. Page-specific behavior (counters, process loop, FAQ, etc.)
// lives in each section's own script, not here. Cookie consent is handled by
// Shopify's native customer privacy banner, not a custom implementation.

// ─── Loading Screen ───
window.addEventListener('load', () => {
    setTimeout(() => {
        document.getElementById('loader')?.classList.add('hidden');
    }, 2200);
});

// ─── Custom Cursor ───
const dot = document.getElementById('cursorDot');
const ring = document.getElementById('cursorRing');

if (dot && ring && window.matchMedia('(hover: hover)').matches) {
    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;
    let hasMoved = false;

    document.addEventListener('mousemove', (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
        dot.style.left = mouseX + 'px';
        dot.style.top = mouseY + 'px';
        if (!hasMoved) {
            hasMoved = true;
            ringX = mouseX;
            ringY = mouseY;
        }
        // Only hide the native cursor once we have a real position to show instead.
        document.documentElement.classList.add('cursor-active');
    });

    // When the pointer moves over an embedded iframe (e.g. Shopify's cookie-consent
    // banner), mousemove stops firing on this document — the custom cursor would
    // freeze mid-air with no visible pointer at all. Restore the native cursor
    // until the pointer re-enters the page.
    document.addEventListener('mouseout', (e) => {
        if (!e.relatedTarget) {
            document.documentElement.classList.remove('cursor-active');
        }
    });

    function animateRing() {
        ringX += (mouseX - ringX) * 0.12;
        ringY += (mouseY - ringY) * 0.12;
        ring.style.left = ringX + 'px';
        ring.style.top = ringY + 'px';
        requestAnimationFrame(animateRing);
    }
    animateRing();

    document.querySelectorAll('a, button').forEach(el => {
        el.addEventListener('mouseenter', () => {
            dot.classList.add('hover');
            ring.classList.add('hover');
        });
        el.addEventListener('mouseleave', () => {
            dot.classList.remove('hover');
            ring.classList.remove('hover');
        });
    });
}

// ─── Scroll Reveal ───
const reveals = document.querySelectorAll('.reveal');
const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
        }
    });
}, { threshold: 0.15 });

reveals.forEach(el => revealObserver.observe(el));

// ─── Counter Animation ───
// Identical markup/behavior is reused across templates (homepage, academy, etc.),
// so it lives here instead of being duplicated per page-specific asset.
const counters = document.querySelectorAll('.stat-number[data-target]');
const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const el = entry.target;
            const target = parseInt(el.dataset.target);
            const suffix = el.querySelector('.plus')?.textContent || '';
            let current = 0;
            const increment = target / 60;
            const timer = setInterval(() => {
                current += increment;
                if (current >= target) {
                    current = target;
                    clearInterval(timer);
                }
                el.innerHTML = Math.floor(current) + `<span class="plus">${suffix}</span>`;
            }, 30);
            counterObserver.unobserve(el);
        }
    });
}, { threshold: 0.5 });

counters.forEach(el => counterObserver.observe(el));

// ─── Mobile Menu ───
const menuToggle = document.getElementById('menuToggle');
const navLinks = document.getElementById('navLinks');

if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
        navLinks.classList.toggle('mobile-open');
        menuToggle.classList.toggle('active');
    });
}

// ─── Smooth Scroll ───
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
            navLinks?.classList.remove('mobile-open');
            menuToggle?.classList.remove('active');
        }
    });
});

// ─── Navbar scroll effect ───
// Toggles a class instead of writing inline padding on every scroll event,
// and only touches the DOM when the state actually flips (was: writing
// style.padding on every single scroll tick, even when nothing changed).
const navEl = document.querySelector('.nav');
let navScrolled = false;

window.addEventListener('scroll', () => {
    if (!navEl) return;
    const shouldBeScrolled = window.scrollY > 100;
    if (shouldBeScrolled !== navScrolled) {
        navScrolled = shouldBeScrolled;
        navEl.classList.toggle('nav--scrolled', navScrolled);
    }
});
